import {
  ConfirmationBox,
  HeadingGroup,
  ModalLayout,
  OffCanvasLayout,
  Pagination,
  SearchFilters,
  Table,
} from "@wac-ui-dashboard/wac_component_library";
import { FaSort } from "react-icons/fa";
// import { ImageCard } from "../../Global/ImageCard";
import OrderColumn from "../../Global/OrderColumn/index";
import EmptyData from "../../Global/EmptyData";
import useSplashScrreen from "./useSplashScrreen";
import AddSplashScreen from "./AddSplashScreen";
import VideoCard from "../../Global/VideoCard";
import Style from "./splashScreen.module.scss";

const SplashScrreen = () => {
  const {
    isLoading,
    isFetching,
    splashScreenList,
    showEditModal,
    splashScreenState,
    paginationOptions,
    handleEditColumnsClick,
    updateSplashScreenFields,
    handleDeleteModal,
    handleDelete,
    handleCreateClick,
    handlePagination,
    handleClearClick,
    handleEditAction,
    closeVideoModal,
    handlePageSize,
    handleSearch,
    handleSort,
    refetch,
    getRow,
    showVideoModal,
    videoData,
    pendingToggle,
    handleConfirmToggle,
    handleCancelToggle,
  } = useSplashScrreen();

  return (
    <div>
      <HeadingGroup
        title={"Splash Screen"}
        className={`pro-mb-4`}
        // buttonTitle={splashScreenList?.data?.create_permission && "Create"}
        buttonTitle={"Create"}
        handleClick={handleCreateClick}
      />
      <div className="col-auto pro-pt-3 pro-pb-6">
        <SearchFilters
          onSearchInput={handleSearch}
          loading={isLoading}
          SearchIcon={
            <span className="material-symbols-outlined"> search </span>
          }
          showClearFilters={splashScreenState?.search === "" ? false : true}
          handleClear={handleClearClick}
          searchInputProps={{ value: splashScreenState?.search }}
          handleActionClick={handleEditColumnsClick}
        />
        {/* Strict false, so nothing flashes while the list is still loading. */}
        {splashScreenList?.data?.has_active_all_users_screen === false && (
          <div className={`${Style.notice} pro-mb-4`}>
            No splash screen is active for common users. Customers who are not on
            a number list will not see any splash screen until you add one with
            the number field left empty.
          </div>
        )}

        {splashScreenList?.data?.result?.length === 0 ? (
          <EmptyData />
        ) : (
          <Table
            multiSelect={false}
            data={splashScreenList?.data?.result || []}
            uniqueID={"id"}
            fields={splashScreenList?.fields || []}
            SortIcon={<FaSort />}
            editIcon={<span className="material-symbols-outlined">edit</span>}
            deleteIcon={
              <span className="material-symbols-outlined">delete</span>
            }
            handleSort={handleSort}
            getRow={getRow}
            clear={splashScreenState?.clearSelection}
            loading={isFetching}
            perpage={splashScreenState?.currentPageSize}
            assignable={false}
            handleEdit={handleEditAction}
            handleDelete={handleDeleteModal}
            deletable={splashScreenList?.delete_permission}
            editable={splashScreenList?.edit_permission}
            showCheckBox={
              splashScreenList?.delete_permission ||
              splashScreenList?.edit_permission
            }
          />
        )}

        {splashScreenList?.data?.result?.length > 0 && (
          <Pagination
            currentPage={splashScreenState?.currentPage}
            totalPageCount={Math.ceil(
              splashScreenList?.data?.total_count / splashScreenState.currentPageSize
            )}
            defaultValue={paginationOptions?.filter(
              (item) => item?.value === splashScreenState?.currentPageSize
            )}
            onPageChange={handlePagination}
            options={paginationOptions}
            onActionChange={handlePageSize}
            center
          />
        )}
        <ModalLayout
          show={splashScreenState?.showDeleteModal}
          handleClose={handleDeleteModal}
        >
          <div className="pro-m-5">
            <ConfirmationBox
              title={"Are you sure to delete the selected Splash Screen ?"}
              subTitle={"This action can't be undo "}
              cancelText={"No"}
              cancelAction={handleDeleteModal}
              submitText={"Yes"}
              submitAction={handleDelete}
              isRight={true}
            />
          </div>
        </ModalLayout>

        <ModalLayout
          show={Boolean(pendingToggle)}
          handleClose={handleCancelToggle}
          backdrop="static"
        >
          <div className="pro-m-5">
            <ConfirmationBox
              title={"No splash screen will be active for common users"}
              subTitle={
                "This is the only splash screen shown to users who aren't on a number list. Switching it off will leave them with no splash screen until you set up another one for all users."
              }
              cancelText={"Go Back"}
              cancelAction={handleCancelToggle}
              submitText={"Switch Off Anyway"}
              submitAction={handleConfirmToggle}
              isRight={true}
            />
          </div>
        </ModalLayout>

        <ModalLayout
          show={showEditModal}
          handleClose={handleEditColumnsClick}
          backdrop="static"
        >
          <div className="pro-m-5">
            <OrderColumn
              title={"Choose which columns you see"}
              refetch={refetch}
              tableFields={splashScreenList?.fields || []}
              moduleId={splashScreenList?.module_id}
              updateData={updateSplashScreenFields}
            />
          </div>
        </ModalLayout>
        <OffCanvasLayout
          show={splashScreenState?.showCreateModal}
          handleClose={handleCreateClick}
          title={splashScreenState?.isEdit ? "Update Splash Screen" : "Add Splash Screen"}
          backdrop={"static"}
        >
          <AddSplashScreen
            refetch={refetch}
            handleCreateClick={handleCreateClick}
            isStickyFooter
          />
        </OffCanvasLayout>

       <ModalLayout
          show={showVideoModal}
          handleClose={closeVideoModal}
          backdrop={"static"}
        >
          <VideoCard handleClose={closeVideoModal} data={videoData} />
        </ModalLayout>
      </div>
    </div>
  );
};

export default SplashScrreen;
